module.exports = __webpack_public_path__ + "images/shop/favicon-carpardoo/favicon.ico";